/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Start_AttemptInputs */

const en_player_start_attempt = /** @type {(inputs: Player_Start_AttemptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start attempt`)
};

const ja_player_start_attempt = /** @type {(inputs: Player_Start_AttemptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受験を開始`)
};

const fr_player_start_attempt = /** @type {(inputs: Player_Start_AttemptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer la tentative`)
};

const de_player_start_attempt = /** @type {(inputs: Player_Start_AttemptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuch starten`)
};

/**
* | output |
* | --- |
* | "Start attempt" |
*
* @param {Player_Start_AttemptInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_start_attempt = /** @type {((inputs?: Player_Start_AttemptInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Start_AttemptInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_start_attempt(inputs)
	if (locale === "ja") return ja_player_start_attempt(inputs)
	if (locale === "fr") return fr_player_start_attempt(inputs)
	return de_player_start_attempt(inputs)
});